import * as React from "react";
import { forwardRef } from "react";
const SvgCheckmarkBlue = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 15, height: 12, viewBox: "0 0 15 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M14 1L4 11.01L1 8.01", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgCheckmarkBlue);
export default ForwardRef;
